const optimizationPipelineHu = {
	optimizationPipeline: 'Optimization Pipeline',
	optimizationPipelineV2: 'Optimization Pipeline',
	optimizationPipelineV2EditForm: 'Optimization Pipeline',
	name: 'Name',
	description: 'Description',
	driver: 'Driver',
	model: 'Model',
	dataset: 'Dataset',
	basic: 'Basic',
	input_attributes: 'Input Attributes',
	output_attributes: 'Output Attributes',
	type: 'Type',
	value: 'Value',
	attribute_class: 'Attribute class',
	model_field_name: 'Model field name',
	state: 'State',
	values: 'Values',
	reader: 'Reader',
	summary_type: 'Summary type',
	summary_duration: 'Summary duration',
	summary_duration_type: 'Summary duration type',
	mergedMeasurement: 'Merged Measurement',
	cleanMeasurement: 'Clean Measurement',
	modelValidation: 'Model Validation',
	unitOptimizer: 'Unit Optimizer',
	outlierDetectors: 'Outlier Detectors',
	labMeasurementEntries: 'Lab Measurement Entries',
	piMeasurementEntries: 'PI Measurement Entries',
	piMeasurementReader: 'PI Measurement Reader',
	measurement: 'Measurement',
	optimizationPipelineLog: 'Optimization Pipeline Log',
	labMeasurementReader: 'Lab Measurement Reader',
	simulationMonitor: 'Simulation Monitor',
	piWriter: 'PI Writer',
	edtDynamicCheck: 'EDT Dynamic Check',
	userGroup: 'User Group',
	summaryDuration: 'Summary Duration',
	summaryDurationUnit: 'Summary Duration Unit',
	summaryType: 'Summary Type',
	opcDaWriter: 'OPC DA Writer',
	noTimestampDataTitle: 'Nincs adat',
	noTimestampDataDescription: 'No timestamp data available at this moment.',
};

export default optimizationPipelineHu;
